import * as React from "react";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import DarkModeSwitch, { useDarkMode } from "./components/DarkModeSwitch";
import Home from "./routes/Home";

import { Box, Grommet } from "grommet";
import { normalizeColor } from "grommet/utils";
import { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import styled from "styled-components";
import ErrorBoundary from "./components/ErrorBoundary";
import SkeletonWrapper from "./components/SkeltonWrapper";
import Splash from "./routes/Splash";
import Theme from "./utils/Theme";
import { GetMetadata, Metadata } from "./utils/MetadataStore";
import Profile from "./routes/Profile";
import TreasureHunt from "./routes/TreasureHunt";
import Background from "./components/Background";
import Scanner from "./routes/Scanner";
import Exhibitors from "./routes/Exhibitors";
import ExhibitorDetails from "./routes/ExhibitorDetails";
import FloorPlan from "./routes/FloorPlan";
import Schedule from "./routes/Schedule";
import ScheduleDetails from "./routes/ScheduleDetails";

//@ts-ignore
const ColorSchemeFix = styled.default.div`
    input {
        color-scheme: ${(props: { isDarkMode: any }) => (props.isDarkMode ? "dark" : "light")};
    }
`;

function App() {
    const navigate = useNavigate();

    const [isDarkMode, toggleDarkMode] = useDarkMode();

    const [grommetProps, setGrommetProps] = React.useState({});

    const [isLoading, setIsLoading] = React.useState(true);

    const [metadata, setMetadata] = React.useState({} as Metadata);

    const { pathname } = useLocation();

    React.useEffect(() => {
        GetMetadata().then((res) => {
            setMetadata(res);
            setIsLoading(false);
        });
    }, []);

    React.useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return (
        <>
            {/* <style>{`:root { --accent:${metadata.color} }`}</style> */}
            <Grommet {...grommetProps} full theme={Theme} themeMode={isDarkMode ? "dark" : "light"} style={{ height: "unset" }}>
                {/* @ts-expect-error */}
                <SkeletonTheme baseColor={normalizeColor("transparent", Theme, isDarkMode)} highlightColor={normalizeColor("brand", Theme, isDarkMode)}>
                    {/* <Background> */}
                    <SkeletonWrapper loading={isLoading}>
                        {/* <Box> */}
                        <ColorSchemeFix isDarkMode={isDarkMode}>
                            <Box align="center" style={{ overflow: "hidden" }} background={"white"}>
                                <ErrorBoundary>
                                    <Routes>
                                        <Route path="/home" element={<Home></Home>}></Route>
                                        <Route path="/profile" element={<Profile></Profile>}></Route>
                                        <Route path="/exhibitionZone" element={<TreasureHunt></TreasureHunt>}></Route>
                                        <Route path="/exhibitors" element={<Exhibitors></Exhibitors>}></Route>
                                        <Route path="/exhibitorDetails/:id" element={<ExhibitorDetails></ExhibitorDetails>}></Route>
                                        <Route path="/floorPlans" element={<FloorPlan></FloorPlan>}></Route>
                                        <Route path="/scanner" element={<Scanner></Scanner>}></Route>
                                        <Route path="/schedule" element={<Schedule></Schedule>}></Route>
                                        <Route path="/scheduleDetails/:id" element={<ScheduleDetails></ScheduleDetails>}></Route>
                                        <Route path="/*" element={<Splash></Splash>}></Route>
                                    </Routes>
                                </ErrorBoundary>
                            </Box>
                        </ColorSchemeFix>
                        {/* </Box> */}
                    </SkeletonWrapper>
                    {/* </Background> */}
                </SkeletonTheme>
            </Grommet>
        </>
    );
}

export default App;
